import { createFileRoute } from '@tanstack/react-router';

import { RequestsPage } from '../../../../features/estimates/ui/requests-page.tsx';
import { requirePermissionRoute } from '../../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/estimates/requests/')({
  beforeLoad: requirePermissionRoute('sales.use'),
  component: RequestsPage,
});
